import { Control } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { PatientInput } from '../../../generated/graphql';
import { AssessmentCard, ControlledTextField } from '../shared';
import { rules } from './rules';
import { PersonalDetailFormValues } from './personal-details';
import { selectIsGuardian } from '../../../redux/session';

type PropTypes = {
  control: Control<PersonalDetailFormValues, any>;
  patient: PatientInput;
};

export const PreferredNameAndPronouns = ({ control, patient }: PropTypes) => {
  const isGuardian = useSelector(selectIsGuardian);

  const subtitle = isGuardian
    ? 'What does the patient like to be called?'
    : 'What do you like to be called?';

  return (
    <AssessmentCard>
      <Grid container columnSpacing={1} rowSpacing={2}>
        <Grid item xs={12}>
          <Typography component="h3" variant="h5">
            {subtitle}
          </Typography>
          <Typography variant="body1" component="h3" sx={{ pt: 1 }}>
            Doesn’t have to be {isGuardian ? 'their' : 'your'} legal name. We’ll
            ask that later.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <ControlledTextField<PersonalDetailFormValues>
            name="preferredName"
            control={control}
            defaultValue={patient.preferredName ?? ''}
            rules={rules.preferredName}
            autoComplete="on"
            label="First name"
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField<PersonalDetailFormValues>
            name="patientPronouns"
            control={control}
            defaultValue={patient.patientPronouns ?? ''}
            autoComplete="on"
            label="Add pronouns (optional)"
            inputProps={{ maxLength: 50 }}
          />
          <Typography variant="caption" color="text.secondary" sx={{ mx: 2 }}>
            For example, he, she, they, ze, he/they
          </Typography>
        </Grid>
      </Grid>
    </AssessmentCard>
  );
};
